import useHttpQuery from 'data/firestore/useHttpQuery';
import useDebouncedValue from 'hooks/useDebouncedValue';
import { PAGE_SIZE } from '../../../constants';
import buildQueryPath from './helpers/buildQueryPath';
import buildQueryKey from './helpers/buildQueryKey';
import { SearchCustomersQuery, SearchCustomersResponse } from './types';

const useSearchCustomers = ({
    agentId = '',
    searchQuery,
    createdAt,
    preferredLanguage,
    tags,
    hasNewMessage,
    sortBy = 'createdAt',
    sortOrder = 'desc',
    pageSize = PAGE_SIZE,
    page = 1,
    queryOptions = { enabled: true },
}: SearchCustomersQuery) => {
    const debouncedQuery = useDebouncedValue(searchQuery);

    return useHttpQuery<SearchCustomersResponse>({
        key: buildQueryKey({
            agentId,
            searchQuery: debouncedQuery,
            createdAt,
            preferredLanguage,
            tags,
            hasNewMessage,
            sortBy,
            sortOrder,
            pageSize,
            page,
        }),
        pathname: buildQueryPath({
            basePath: `/agents/${agentId}/customers/search`,
            filters: {
                searchQuery: debouncedQuery,
                createdAt,
                preferredLanguage,
                tags,
                hasNewMessage,
                sortBy,
                sortOrder,
                pageSize,
                page,
            },
        }),
        queryOptions: {
            ...queryOptions,
            enabled: queryOptions.enabled && !!agentId,
        },
    });
};

export default useSearchCustomers;
